import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Select,
  MenuItem,
  IconButton,
  Menu,
  DialogTitle,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
// import UpdateRegistration from "./UpdateRegistration/UpdateRegistration";
import { FaEdit, FaSearch } from "react-icons/fa";
import { BsTrash } from "react-icons/bs";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useNavigate } from "react-router-dom";
import "./ScoreIndex.css";
import UpdateScore from "./UpdateScore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import batakPro from "../Images/batak-pro-name.png"

const ScoreIndex = () => {
  const admin_id = sessionStorage.getItem('admin_id');
  const navigate = useNavigate();
  const [scoreData, setScoreData] = useState([]);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [updateData, setUpdateData] = useState();
  const [openDlt, setOpenDlt] = useState(false);
  const [dltData, setDltData] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredDatas, setFilteredDatas] = useState([]);
  const [dataPerPage, setDataPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    axios
      .get(`https://batak-pro-server.xicsolutions.in/score/getUserScoreData`)
      .then((res) => {
        setScoreData(res.data);
        setFilteredDatas(res.data);
      })
      .catch((err) => {
        console.log("Registration Data is not fetched.", err);
      });
  }, [openUpdate, openDlt]);

  useEffect(() => {
    const lowercasedQuery = searchQuery.toLowerCase();
    const filtered = scoreData.filter((item) => {
      return (
        (item.user_name && item.user_name.toLowerCase().includes(lowercasedQuery)) ||
        (item.email && item.email.toLowerCase().includes(lowercasedQuery)) ||
        (item.phone_no && item.phone_no.toLowerCase().includes(lowercasedQuery)) ||
        (item.country && item.country.toLowerCase().includes(lowercasedQuery)) ||
        (item.unique_id && item.unique_id.toLowerCase().includes(lowercasedQuery))
      );
    });
    setFilteredDatas(filtered);
  }, [searchQuery, scoreData]);

  const handleUpdate = (id) => {
    const selectData = scoreData.find((score) => score.score_id === id);
    if (selectData) {
      setOpenUpdate(true);
      setUpdateData(selectData);
    }
  };

  const handleUpdateSuccessMsg = () => {
    setOpenUpdate(false);
    toast.success("Score Data Updated Successfully.", { autoClose: 3000 })
  }

  const handleDlt = (id) => {
    if (id) {
      setDltData(id);
      setOpenDlt(true);
    }
  };

  const handleConfirmDlt = () => {
    if (dltData) {
      axios
        .delete(
          `https://batak-pro-server.xicsolutions.in/score/deleteUserScore/${dltData}`
        )
        .then((res) => {
          setOpenDlt(false);
        })
        .catch((err) => {
          console.log("Error Failed to delete data.", err);
        });
    }
  };

  const handleSelectRow = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      setSelectedRows(scoreData.map((score) => score.score_id));
    }
    setSelectAll(!selectAll);
  };

  const handleExport = () => {
    if (selectedRows.length === 0) {
      toast.warning("Please select data .", { autoClose: 3000 });
    } else {
      const exportData = scoreData
        .filter((score) => selectedRows.includes(score.score_id))
        .map((score, index) => ({
          "S.No": index + 1,
          "Unique Id": score.unique_id,
          Name: score.user_name,
          "Mobile No": score.phone_no,
          "Mail Id": score.email,
          Score: score.score,
          admin_name: score.admin_name,
        }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Score Data");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(data, "score_date.xlsx");
    }
  };

  const handleChangeDataPerPage = (e) => {
    const newDataPerPage =
      e.target.value === scoreData.length
        ? scoreData.length
        : parseInt(e.target.value, 10);
    setDataPerPage(newDataPerPage);
    setCurrentPage(1);
  };

  const firstIndexOfData = (currentPage - 1) * dataPerPage;
  const lastIndexOfData = currentPage * dataPerPage;
  const currentData = filteredDatas.slice(firstIndexOfData, lastIndexOfData);

  const handleActions = (event, id) => {
    setAnchorEl(event.currentTarget);
    setSelectedId(id);
  };

  const handleClose = () => {
    setOpenUpdate(false);
  };

  return (
    <div className="registration-index-section">
      <Container>
        <ToastContainer position="top-right" />
        <Row>
        <Col xs={12} className="d-flex justify-content-center">
            {/* <h1 className="text-center" style={{ color: 'red',fontWeight:'bold',fontFamily:'Gellix' }}>GRABOW CHALLENGE</h1> */}
            <img src={batakPro} className="grabow-img" alt="grabow-img" />
          </Col>
          <Col xs={12}>
            <h1
              className="text-center"
              style={{
                color: "white",
                fontWeight: "bold",
                fontFamily: "Gellix",
              }}
            >
              SCORE INDEX
            </h1>
          </Col>
        </Row>

        <Row className="mt-5 mb-5">
          <Col
            xs={12}
            md={4}
            lg={4}
            className="d-flex justify-content-lg-start justify-content-md-start justify-content-center mt-md-0 mt-3"
          >
            <Button
              onClick={() => navigate(`/regForm/${admin_id}`)}
              className="navigate-btns"
            >
              Add
            </Button>

            <Button
              onClick={() => navigate("/adminIndex")}
              className="navigate-btns ms-3"
            >
              Home
            </Button>
          </Col>
          <Col
            xs={12}
            md={4}
            lg={4}
            className="d-flex justify-content-lg-start justify-content-md-end justify-content-center mt-md-0 mt-3"
          >
            <div className="search-container">
              <div className="input-container">
                <input
                  type="text"
                  placeholder="Search..."
                  aria-label="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <FaSearch className="searchicon" />
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={4}
            lg={2}
            className="d-flex justify-content-lg-start justify-content-md-end justify-content-center mt-md-0 mt-3"
          >
            <Button onClick={handleExport} className="navigate-btns">
              Export
            </Button>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={2}
            className="d-flex justify-content-lg-end justify-content-md-center justify-content-center mt-md-5 mt-lg-0 mt-3"
          >
            <Select
              className="pagination-btn"
              value={dataPerPage}
              onChange={handleChangeDataPerPage}
            >
              <MenuItem value={20}>20 Per Page</MenuItem>
              <MenuItem value={30}>30 Per Page</MenuItem>
              <MenuItem value={50}>50 Per Page</MenuItem>
              <MenuItem value={scoreData.length}>All Per Page</MenuItem>
            </Select>
          </Col>
        </Row>
        <TableContainer className="registration-table-container table-container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    backgroundColor: "#6000d9",
                    color: "white",
                    fontFamily: "Gellix",
                    fontWeight: "bold",
                    fontSize: "1em",
                  }}
                >
                  S.NO
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "#6000d9",
                    color: "white",
                    fontFamily: "Gellix",
                    fontWeight: "bold",
                    fontSize: "1em",
                  }}
                >
                  PHOTO
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "#6000d9",
                    color: "white",
                    fontFamily: "Gellix",
                    fontWeight: "bold",
                    fontSize: "1em",
                  }}
                >
                  UNIQUE ID
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "#6000d9",
                    color: "white",
                    fontFamily: "Gellix",
                    fontWeight: "bold",
                    fontSize: "1em",
                  }}
                >
                  NAME
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "#6000d9",
                    color: "white",
                    fontFamily: "Gellix",
                    fontWeight: "bold",
                    fontSize: "1em",
                  }}
                >
                  MOBILE NO
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "#6000d9",
                    color: "white",
                    fontFamily: "Gellix",
                    fontWeight: "bold",
                    fontSize: "1em",
                  }}
                >
                  MAIL ID
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "#6000d9",
                    color: "white",
                    fontFamily: "Gellix",
                    fontWeight: "bold",
                    fontSize: "1em",
                  }}
                >
                  SCORE
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "#6000d9",
                    color: "white",
                    fontFamily: "Gellix",
                    fontWeight: "bold",
                    fontSize: "1em",
                  }}
                >
                  ENTERED BY
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "#6000d9",
                    color: "white",
                    fontFamily: "Gellix",
                    fontWeight: "bold",
                    fontSize: "1em",
                  }}
                >
                  ACTIONS
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "#6000d9",
                    color: "white",
                    fontFamily: "Gellix",
                    fontWeight: "bold",
                    fontSize: "1em",
                  }}
                >
                  <Checkbox
                    checked={selectAll}
                    onChange={handleSelectAll}
                    inputProps={{ "aria-label": "select all" }}
                    sx={{
                      color: 'white',
                      '&.Mui-checked': {
                        color: 'white',
                      },
                    }}
                  />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {currentData.map((score, index) => (
                <>
                  <TableRow key={score.score_id} className="table-row" sx={{ '&:last-child td, &:last-child td': { borderBottom: 0 } }}>
                    <TableCell className="table-cell-value">
                      {index + 1}
                    </TableCell>
                    <TableCell className="table-cell-value">
                      <img
                        src={`https://batak-pro-server.xicsolutions.in/uploads/${score.user_img}`}
                        alt={score.user_name}
                        style={{
                          width: "50px",
                          height: "53px",
                          borderRadius: "5px",
                        }}
                      />
                    </TableCell>
                    <TableCell className="table-cell-value">
                      {score.unique_id}
                    </TableCell>
                    <TableCell className="table-cell-value">
                      {score.user_name}
                    </TableCell>
                    <TableCell className="table-cell-value">
                      {score.phone_no}
                    </TableCell>
                    <TableCell className="table-cell-value">
                      {score.email}
                    </TableCell>
                    <TableCell className="table-cell-value">
                      {score.score}
                    </TableCell>
                    <TableCell className="table-cell-value">
                      {score.admin_name}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={(e) => handleActions(e, score.score_id)}
                      >
                        <MoreVertIcon style={{ color: 'white' }} />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={
                          Boolean(anchorEl) && selectedId === score.score_id
                        }
                        onClose={() => setAnchorEl(null)}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <MenuItem onClick={() => handleUpdate(score.score_id)}>
                          <FaEdit />
                          &nbsp;&nbsp; Edit
                        </MenuItem>
                        <MenuItem onClick={() => handleDlt(score.score_id)}>
                          <BsTrash />
                          &nbsp;&nbsp; Delete
                        </MenuItem>
                      </Menu>
                    </TableCell>
                    <TableCell>
                      <Checkbox
                        checked={selectedRows.includes(score.score_id)}
                        onChange={() => handleSelectRow(score.score_id)}
                        inputProps={{
                          "aria-label": `select ${score.score_id}`,
                        }}
                        sx={{
                          color: 'white',
                          '&.Mui-checked': {
                            color: 'white',
                          },
                        }}
                      />
                    </TableCell>
                  </TableRow>
                </>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Row className="mt-3">
          <Col xs={12} className="d-flex justify-content-center">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(filteredDatas.length / dataPerPage)}
                page={currentPage}
                onChange={(e, value) => setCurrentPage(value)}
                sx={{
                  '& .MuiPaginationItem-root': {
                    color: 'white',
                    backgroundColor: '#6000d9',
                  }
                }}
              />
            </Stack>
          </Col>
        </Row>
      </Container>

      {openUpdate && (
        <UpdateScore
          data={updateData}
          open={openUpdate}
          close={() => handleClose()}
          successMsg={handleUpdateSuccessMsg}
        />
      )}

      <Dialog
        open={openDlt}
        onClose={() => setOpenDlt(false)}
        maxWidth="md"
        PaperProps={{
          style: {
            background: 'rgba(5, 5, 5, 0.18)',
            backdropFilter: 'blur(10px)',
            padding:'2rem 5rem 1rem 5rem',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '16px',
            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)'
          }
        }}
      >
        <DialogTitle  >

          <h5 style={{
            textAlign: "center",
            color: "white",
            fontSize: '1.25rem',
            fontWeight: 500
          }}>
            Conform Deletion
          </h5>

        </DialogTitle>

        <DialogContent >
          <p style={{
            fontSize: '1.1rem',
            color: "white",
            margin: 0
          }}>
            Are you sure you want to delete this user score?
            <br />
            <span style={{
              fontWeight: 600,
              color: 'rgb(255, 1, 26, 0.88)'
            }}>
              This action cannot be undone.
            </span>
          </p>
        </DialogContent>

        <DialogActions
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '1.5rem',
            borderTop: '1px solid rgba(0, 0, 0, 0.1)'
          }}
        >
          <button
            onClick={() => setOpenDlt(false)}
            style={{
              padding: '8px 16px',
              fontSize: '1rem',
              border: '1px solid white ',
              borderRadius: '6px',
              background: 'rgba(108, 117, 125, 0.1)',
              backdropFilter: 'blur(5px)',
              color: 'white',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              '&:hover': {
                background: 'rgba(108, 117, 125, 0.2)'
              }
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirmDlt}
            style={{
              padding: '8px 16px',
              fontSize: '1rem',
              border: '1px solid rgba(220, 53, 69, 0.5)',
              borderRadius: '6px',
              background: 'rgba(255, 1, 26, 0.88)',
              backdropFilter: 'blur(5px)',
              color: 'white',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              marginLeft: '8px',
              '&:hover': {
                background: 'rgba(220, 53, 69, 0.2)'
              }
            }}
          >
            Delete
          </button>
        </DialogActions>
      </Dialog>

    </div>
  );
};

export default ScoreIndex;
